"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("@/components");
var _TableListLivenesPerson = _interopRequireDefault(require("./components/TableListLivenesPerson"));
var _vuex = require("vuex");
var _lodash = _interopRequireDefault(require("lodash"));
var _clientsListMixin = require("@/mixins/clientsListMixin");
var _auth = require("@/utils/auth");
var _validate = require("@/utils/validate");
var _constants = require("@/config/constants");
var _onboardingStatus = require("@/utils/onboardingStatus");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var validCPF = function validCPF(value) {
  return !value || (0, _validate.validateCPF)(value);
};
var _default = exports.default = {
  name: 'LivenessHive',
  bodyClass: 'liveness-hive-list-page',
  components: {
    TableListLivenesPerson: _TableListLivenesPerson.default,
    AppInput: _components.AppInput,
    AppSelect: _components.AppSelect
  },
  mixins: [_clientsListMixin.clientsListMixin],
  data: function data() {
    return {
      filter: '',
      listItems: [],
      page: 1,
      limit: 10,
      total: 0,
      form: {
        document: '',
        hiveId: ''
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['listBusinessUnits', 'filterBusinessLifeProof', 'filterOrganizationLifeProof', 'filterStatusLifeProof'])), {}, {
    listOrganizations: function listOrganizations() {
      return _lodash.default.orderBy(this.listAllClients, ['name']);
    },
    listStatusOptions: function listStatusOptions() {
      return [{
        id: 'all',
        name: this.$t('statuses.onboarding.all')
      }].concat(_toConsumableArray(_constants.LIST_STATUS_ONBOARDING.map(function (status) {
        return _objectSpread(_objectSpread({}, status), {}, {
          name: (0, _onboardingStatus.getOnboardingStatusLabel)(status.id, status.name)
        });
      })));
    },
    listClients: function listClients() {
      var _this = this;
      if (this.listItems.length) {
        if (this.filter) {
          return this.listItems.filter(function (p) {
            if (p.document) {
              var verify = p.document.indexOf(_this.filter.toUpperCase()) >= 0;
              if (verify) return verify;
            }
          });
        }
      }
      return this.listItems;
    },
    user: function user() {
      return (0, _auth.getUser)().user;
    },
    isAdmin: function isAdmin() {
      return this.user.roleAdmin;
    },
    filterStatus: {
      get: function get() {
        return this.filterStatusLifeProof;
      },
      set: function set(value) {
        this.setFilterStatusLifeProof(_typeof(value) === 'object' ? _objectSpread({}, value) : value);
      }
    },
    filterBusiness: {
      get: function get() {
        return this.filterBusinessLifeProof;
      },
      set: function set(value) {
        this.setFilterBusinessLifeProof(_typeof(value) === 'object' ? _objectSpread({}, value) : value);
      }
    },
    filterOrganization: {
      get: function get() {
        return this.filterOrganizationLifeProof;
      },
      set: function set(value) {
        this.setFilterOrganizationLifeProof(_typeof(value) === 'object' ? _objectSpread({}, value) : value);
      }
    }
  }),
  watch: {
    page: function page() {
      this.getList();
    },
    filterStatus: function filterStatus() {
      this.getList();
    },
    filterBusiness: function filterBusiness() {
      this.getList();
    },
    filterOrganization: function filterOrganization() {
      this.fetchBusinessUnits(this.filterOrganization);
      this.listBUs = this.listBusinessUnits;
    }
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            this.getList();
          case 1:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  validations: function validations() {
    return {
      form: {
        document: {
          validCPF: validCPF
        }
      }
    };
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['fetchListLivenessHive', 'fetchBusinessUnits', 'setFilterBusinessLifeProof', 'setFilterOrganizationLifeProof', 'setFilterStatusLifeProof'])), {}, {
    buildListParams: function buildListParams() {
      var _this$form$document, _this$form$hiveId;
      var document = (_this$form$document = this.form.document) === null || _this$form$document === void 0 ? void 0 : _this$form$document.trim();
      var hiveId = (_this$form$hiveId = this.form.hiveId) === null || _this$form$hiveId === void 0 ? void 0 : _this$form$hiveId.trim();
      return _objectSpread(_objectSpread({
        page: this.page,
        limit: this.limit,
        status: this.filterStatus,
        business: this.filterBusiness
      }, document ? {
        document: document
      } : {}), hiveId ? {
        hiveId: hiveId
      } : {});
    },
    getList: function () {
      var _getList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var params, _yield$this$fetchList, data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              params = this.buildListParams();
              _context2.n = 1;
              return this.fetchListLivenessHive(params);
            case 1:
              _yield$this$fetchList = _context2.v;
              data = _yield$this$fetchList.data;
              if (data) {
                this.listItems = data.rows;
                this.total = data.totalRegisters;
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    openModalNew: function openModalNew() {
      this.$buefy.modal.open({
        parent: this,
        component: _components.ModalGenerateLinkLifeProof,
        hasModalCard: true,
        customClass: 'modal-generate-link-life-proof',
        trapFocus: true,
        canCancel: ['x'],
        props: {}
      });
    },
    openDetail: function openDetail(item) {
      this.$router.push({
        path: "/liveness-hive/detail/".concat(item._id)
      });
    },
    handleSearchDocument: function () {
      var _handleSearchDocument = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(e) {
        var _this$form$document2, _this$form$hiveId2;
        var document, hiveId, shouldLoadByWatcher;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              e.preventDefault();
              this.$v.$touch();
              document = (_this$form$document2 = this.form.document) === null || _this$form$document2 === void 0 ? void 0 : _this$form$document2.trim();
              hiveId = (_this$form$hiveId2 = this.form.hiveId) === null || _this$form$hiveId2 === void 0 ? void 0 : _this$form$hiveId2.trim();
              if (!(document && hiveId)) {
                _context3.n = 1;
                break;
              }
              this.$buefy.toast.open({
                duration: 5000,
                message: 'Informe apenas um filtro por vez: CPF ou Hive ID.',
                position: 'is-top',
                type: 'is-danger'
              });
              return _context3.a(2);
            case 1:
              if (!(document && this.$v.$invalid)) {
                _context3.n = 2;
                break;
              }
              this.$buefy.toast.open({
                duration: 5000,
                message: 'Informe um CPF valido para realizar a busca.',
                position: 'is-top',
                type: 'is-danger'
              });
              return _context3.a(2);
            case 2:
              shouldLoadByWatcher = this.page !== 1;
              this.page = 1;
              if (!shouldLoadByWatcher) {
                _context3.n = 3;
                break;
              }
              return _context3.a(2);
            case 3:
              _context3.n = 4;
              return this.getList();
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function handleSearchDocument(_x) {
        return _handleSearchDocument.apply(this, arguments);
      }
      return handleSearchDocument;
    }(),
    handlerUpdatePage: function handlerUpdatePage() {
      location.reload();
    }
  })
};